// Лентата „проследяване": показва по коя сметка или маса е стеснен списъкът.
//
// Проследяването НАРОЧНО изключва периода. Една сметка живее през полунощ и с
// избран „Днес" половината ѝ история липсва, без нищо да подсказва защо.
// Излизането от проследяването връща периода, който е бил избран преди него.

import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export type AuditFocus =
  | { kind: "bill"; billId: number; tableName: string | null }
  | { kind: "table"; tableName: string };

type Props = {
  focus: AuditFocus;
  /** Колко реда има следата — казва се тук, за да не се брои от пейджъра. */
  count: number;
  onExit: () => void;
};

export const AuditFocusBar = ({ focus, count, onExit }: Props) => {
  const { t } = useTranslation();

  const title =
    focus.kind === "bill"
      ? t("auditLog.trace.billTitle", {
          id: focus.billId,
          table: focus.tableName ?? "—",
        })
      : t("auditLog.trace.tableTitle", { name: focus.tableName });

  return (
    <section className="flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-[14px] border border-brand-tint2 bg-brand-tint px-4 py-3">
      <span className="font-pos-mono text-[10px] font-bold uppercase leading-none tracking-[0.1em] text-brand-deep-ink">
        {t("auditLog.trace.kicker")}
      </span>
      <span className="min-w-0 flex-1 text-[14px] font-extrabold leading-[1.2] text-ink">
        {title}
        <span className="ml-2 font-pos-mono text-[12px] font-semibold tabular-nums text-brand-deep-ink">
          {count === 1
            ? t("auditLog.trace.countOne", { count })
            : t("auditLog.trace.count", { count })}
        </span>
      </span>
      <span className="text-[11.5px] font-medium leading-[1.2] text-brand-deep-ink">
        {t("auditLog.trace.periodOff")}
      </span>
      <button
        type="button"
        onClick={onExit}
        className="inline-flex h-8 items-center gap-1.5 rounded-lg border border-brand-tint2 bg-surface px-3 text-[12.5px] font-bold text-brand-deep-ink transition-colors hover:bg-brand-tint2"
      >
        <CloseOutlined className="text-[11px]" />
        {t("auditLog.trace.exit")}
      </button>
    </section>
  );
};
